import React, { useEffect, useState } from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link, useNavigate, useParams } from "react-router-dom"
import { Row, Form, Modal } from "reactstrap"
import Select from "react-select"

// editor
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"

// assets
import "../../../assets/css/Sales/Sales.css"
import Loader from "pages/Separate/Loader"
import configure from "configure"
import { fetchData, fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"
import { useSelector } from "react-redux"
import { colourStyles, TenderStatus } from "utils/common-options"

const AddTender = () => {
    const [fixButtons, setFixButtons] = useState(false)

    const navigate = useNavigate()
    const params = useParams()



    const [location, setLocation] = useState([])
    const [isLoading, setLoading] = useState(false)
    const token = secureLocalStorage.getItem('auth_token')
    const [addTenderName, setAddTenderName] = useState("")
    const [addApplyDate, setAddApplyDate] = useState("")
    const [addSubmissionDate, setAddSubmissionDate] = useState("")
    const [addContractValue, setAddContractValue] = useState("")
    const [addCurrency, setAddCurrency] = useState("")
    const [addStatus, setAddStatus] = useState("")
    const [addFile, setAddFile] = useState("")
    const [addEditorData, setAddEditorData] = useState("")
    const [file, setFile] = useState(null)
    const getLocations = useSelector(state => state?.location?.locations)
    const generalData = useSelector(state => state?.GeneralData?.generalData)
    const [assignee, setAssignee] = useState([])
    const [communicator, setCommunicator] = useState([])
    const [duration, setDuration] = useState('')
    const [prerequisites, setPrerequisites] = useState('')
    const [company, setCompany] = useState('')
    const [companyEmail, setCompanyEmail] = useState('')
    const [companyNumber, setCompanyNumber] = useState('')
    const [companyAddress, setCompanyAddress] = useState('')
    const [contactName, setContactName] = useState('')
    const [contactPhone, setContactPhone] = useState('')
    const [contactEmail, setContactEmail] = useState('')
    const [currency_option, setCurrencyOption] = useState([])

    document.addEventListener("scroll", () => {
        if (window.scrollY > 160) {
            setFixButtons(true)
        } else {
            setFixButtons(false)
        }
    })
    const fetchCurrency = async () => {
        setLoading(true)
        const res = await fetchData(setLoading, 'currency', token);
        if (res?.success) {
            setCurrencyOption(res.data.currency.map(item => ({
                label: item.symbol + "-" + item.currency,
                value: item.id,
            })))
        }
    }

    useEffect(() => {
        fetchCurrency()
    }, [])



    const handleAddSubmit = async e => {
        e.preventDefault()
        const user_id = localStorage.getItem("auth_id")
        const formData = {
            user_id: user_id,
            location: location,
            tenderName: addTenderName,
            applyDate: addApplyDate,
            source: params?.id,
            file: file,
            submissionDate: addSubmissionDate,
            aboutTender: addEditorData,
            budget: parseFloat(addContractValue),
            currency: parseInt(addCurrency),
            status: addStatus,
            tenderCommunicator: communicator?.value,
            projectPrerequisite: prerequisites,
            projectDuration: duration,
            tenderAssignee: assignee?.value,
            company_name: company,
            company_email: companyEmail,
            company_phone: companyNumber,
            company_address: companyAddress,
            contact_name: contactName,
            contact_email: contactEmail,
            contact_phone: contactPhone
        }

        try {
            const response = await FetchNodePostData(
                setLoading,
                "/tender",
                localStorage.getItem("auth_token"),
                formData
            )
            if (response.status == 200) {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Tender Added successfully",
                })
                navigate(`${configure.appUrl}marketing/tender`)
            } else {
                Swal.fire({
                    icon: "error",
                    title: "error",
                    text: response.data.message,
                })
            }
        } catch (error) {
            console.log(error)
            Swal.fire({
                icon: "error",
                title: "error",
                text: error.message,
            })
        }
    }




    return (
        <React.Fragment>
            {isLoading && <Loader />}
            <div className="page-content mb-3">
                <Container fluid>
                    <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Add Tender"} />
                    <Row className="px-1">
                        <Form onSubmit={handleAddSubmit}>
                            <div
                                className={`flex-column fixed-buttons pt-2 ${fixButtons ? "d-flex" : "d-none"
                                    }`}
                            >
                                <button
                                    type="submit"
                                    className="btn btn-save fix-btn btn-label pe-0"
                                >
                                    <i className="fas fa-save me-2 label-icon"></i>
                                    <span>Save</span>
                                </button>
                                <a
                                    onClick={() => navigate(-1)}
                                    className="btn btn-red  fix-btn  btn-label pe-0"
                                >
                                    <i className="dripicons-cross me-2 icon-center label-icon"></i>
                                    <span>Cancel</span>
                                </a>
                            </div>
                            <Row className="bg-white px-2 py-4 shadow mb-3">
                                <div className="col-md-6 mb-3">
                                    <h5 className="mb-3">Tender Information</h5>
                                </div>
                                <div className="col-md-6 mb-3 text-end">
                                    <button
                                        type="submit"
                                        onClick={e => handleAddSubmit(e)}
                                        className=" btn ms-md-2 btn-save  btn-label"
                                    >
                                        <i className="fas fa-save me-1 label-icon"></i> save
                                    </button>
                                    <a
                                        onClick={e => {
                                            navigate(-1)
                                        }}
                                        className=" btn ms-md-2 btn-red  btn-label "
                                    >
                                        <i className="dripicons-cross me-2 icon-center label-icon"></i>
                                        CANCEL
                                    </a>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="">Location</label>
                                        <Select
                                            placeholder="Select Location"
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            styles={colourStyles}
                                            options={getLocations}
                                            value={getLocations.find(
                                                option => option.value === location
                                            )}
                                            onChange={e => setLocation(e.value)}
                                        />
                                    </div>
                                    <div className="col-md-9 mb-3">
                                        <label htmlFor="">Tender Name</label>
                                        <input
                                            type="text"
                                            placeholder="Enter Tender Name"
                                            className="form-control"
                                            value={addTenderName}
                                            onChange={e => setAddTenderName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="">Apply Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={addApplyDate}
                                            onChange={e => setAddApplyDate(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="col-md-3">
                                        <label htmlFor="">Tender Submission Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            value={addSubmissionDate}
                                            onChange={e => setAddSubmissionDate(e.target.value)}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="">Budget</label>
                                        <div className="input-group">
                                            <select
                                                className="form-select budget-radius"
                                                style={{
                                                    backgroundColor: "#eff2f7",
                                                    maxWidth: "100px",
                                                }}
                                                value={addCurrency}
                                                onChange={e => setAddCurrency(e.target.value)}
                                                required
                                            >
                                                <option value="">Select</option>
                                                {currency_option.map((obj, i) => (
                                                    <option key={i} value={obj.value}>
                                                        {obj.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <input
                                                type="text"
                                                className="form-control price-border"
                                                style={{
                                                    borderTopLeftRadius: 0,
                                                    borderBottomLeftRadius: 0,
                                                }}
                                                placeholder="Enter Budget"
                                                value={addContractValue}
                                                onChange={e => setAddContractValue(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <label htmlFor="">Status</label>
                                        <Select
                                            placeholder="Status"
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            styles={colourStyles}
                                            options={TenderStatus}
                                            value={TenderStatus?.find(
                                                option => option.value === addStatus
                                            )}
                                            onChange={e => setAddStatus(e.value)}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="">Assignee</label>
                                        <Select
                                            placeholder="Select Assignee"
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            styles={colourStyles}
                                            options={generalData?.staff}
                                            value={assignee}
                                            onChange={e => setAssignee(e)}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="">Tender Communicator</label>
                                        <Select
                                            placeholder="Select Communicator"
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            styles={colourStyles}
                                            options={generalData?.staff}
                                            value={communicator}
                                            onChange={e => setCommunicator(e)}
                                        />
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor=""> Tender Document </label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            onChange={e => setFile(e.target.files[0])}
                                        />
                                    </div>
                                </div>
                            </Row>

                            {/* Company info */}
                            <Row className="bg-white px-2 py-4 shadow mb-3">
                                <h5 className="mb-3">Project Information</h5>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor="">Duration</label>
                                    <input
                                        type="text"
                                        placeholder="Duration (eg 3 years 6 months)"
                                        className="form-control"
                                        value={duration}
                                        onChange={e => setDuration(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="col-12">
                                    <label htmlFor=""> Tender Prerequisites </label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={prerequisites}
                                        onChange={(entity, editor) => {
                                            const data = editor.getData()
                                            setPrerequisites(data)
                                        }}
                                    />
                                </div>
                                <div className="col-12 mt-3">
                                    <label htmlFor="">Project Description</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={addEditorData}
                                        onChange={(entity, editor) => {
                                            const data = editor.getData()
                                            setAddEditorData(data)
                                        }}
                                    />
                                </div>
                            </Row>

                            {/* Address */}
                            <Row className="bg-white px-2 py-4 shadow mb-3">
                                <h5 className="mb-3">Contact Information</h5>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor="">Company Name</label>
                                    <input
                                        type="text"
                                        placeholder="Enter Company Name"
                                        className="form-control"
                                        value={company}
                                        onChange={e => setCompany(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor="">Company Email Address</label>
                                    <input
                                        type="text"
                                        placeholder="Enter Company Email Address"
                                        className="form-control"
                                        value={companyEmail}
                                        onChange={e => setCompanyEmail(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor="">Company Phone No.</label>
                                    <input
                                        type="number"
                                        placeholder="Enter Company Phone No."
                                        className="form-control"
                                        value={companyNumber}
                                        onChange={e => setCompanyNumber(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor="">Company Address</label>
                                    <input
                                        type="text"
                                        placeholder="Enter Company Address"
                                        className="form-control"
                                        value={companyAddress}
                                        onChange={e => setCompanyAddress(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor="">Contact Name</label>
                                    <input
                                        type="text"
                                        placeholder="Enter Contact Name"
                                        className="form-control"
                                        value={contactName}
                                        onChange={e => setContactName(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor="">Contact Email</label>
                                    <input
                                        type="email"
                                        placeholder="Enter Contact Email"
                                        className="form-control"
                                        value={contactEmail}
                                        onChange={e => setContactEmail(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label htmlFor="">Contact Phone No.</label>
                                    <input
                                        type="number"
                                        placeholder="Enter Contact Phone No."
                                        className="form-control"
                                        value={contactPhone}
                                        onChange={e => setContactPhone(e.target.value)}
                                    />
                                </div>
                            </Row>


                        </Form>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default AddTender
